/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_SavedInputs */

const en_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

const fr_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré`)
};

const es_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado`)
};

const it_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvata`)
};

const nl_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeslagen`)
};

const pl_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisano`)
};

const fi_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallennettu`)
};

const da_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemt`)
};

const sv_jobs_status_saved = /** @type {(inputs: Jobs_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparad`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Jobs_Status_SavedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_status_saved = /** @type {((inputs?: Jobs_Status_SavedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_SavedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_status_saved(inputs)
	if (locale === "fr") return fr_jobs_status_saved(inputs)
	if (locale === "es") return es_jobs_status_saved(inputs)
	if (locale === "it") return it_jobs_status_saved(inputs)
	if (locale === "nl") return nl_jobs_status_saved(inputs)
	if (locale === "pl") return pl_jobs_status_saved(inputs)
	if (locale === "fi") return fi_jobs_status_saved(inputs)
	if (locale === "da") return da_jobs_status_saved(inputs)
	if (locale === "sv") return sv_jobs_status_saved(inputs)
	return en_jobs_status_saved(inputs)
});